import React, { useMemo } from "react";
import { isStartListStatus, isLiveStatus, isFinishedStatus } from "helpers/status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
//General
import Status from "components/presentation/Status";
import { filterArray } from 'helpers/utils';
import { getIsIndividual } from 'components/sports/div/helper/DivHelpers'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import PageHeader from "components/common/PageHeader";
import PreviousCompetitor from "components/sports/sjp/views/PreviousCompetitor";
import CurrentCompetitor from "components/sports/sjp/views/CurrentCompetitor";

import {
    TableColumnsTrial as ColumnsTrialStart,
    TableColumnsTrialSM as ColumnsTrialStartSM,
    TableColumnsQual as ColumnsQualStart,
    TableColumnsQual as ColumnsQualStartSM
} from 'components/sports/sjp/events/individual/startTrial/Columns'
import {
    TableColumnsTrialLive as ColumnsTrialLive,
    TableColumnsTrialLiveSM as ColumnsTrialLiveSM,
    TableColumnsTrialFinish as ColumnsTrialFinal,
    TableColumnsTrialFinishSM as ColumnsTrialFinalSM,
    TableColumnsQualLive as ColumnsQualLive,
    TableColumnsQualLiveSM as ColumnsQualLiveSM,
    TableColumnsQualFinish as ColumnsQualFinal,
    TableColumnsQualFinishSM as ColumnsQualFinalSM
} from 'components/sports/sjp/events/individual/resultsTrial/Columns'
import { TableExpanded as TE } from 'components/sports/sjp/events/individual/resultsTrial/TableExpanded'
import StartStatus from 'components/sports/sjp/views/StartStatus'
import ProgressionRule from 'components/common/ProgressionRule'
import SportCode from "components/common/SportCode";
import HillData from 'components/sports/sjp/views/HillData'
import Jury from 'components/sports/sjp/views/Jury'
import Judges from 'components/sports/sjp/views/Judges'

//import TableMin from "components/table/TableMin";
import { useViewport } from 'components/general/useViewPort'
import { findArray } from 'helpers/utils'


const getConfiguration = (data, rsc, resultStatus, breakPoint, caption) => {

    const columnsAdded = data?.config?.extendedConfig ? data.config.extendedConfig.sort((a, b) => a.pos - b.pos) : []
    const scheduleStatus = data?.results?.schedule?.status?.code;
    const isStartList = isStartListStatus(resultStatus) ? true : false
    const isLive = isLiveStatus(resultStatus) ? true : false
    const isIndividual = getIsIndividual(rsc);
    const training = data?.results?.eventUnitCode.includes('TRNO')
    const trial = data?.results?.eventUnitCode.includes('FNL-TR') || data?.results?.eventUnitCode.includes('QUALTR')
    const qual = data?.results?.eventUnitCode.includes('QUAL0001')

    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
        filters: [],
        configs: {
            isStartList: isStartList,
            columnsAdded: columnsAdded,
            previousCurrent: false,
        }
    };

    configuration.caption = isStartList
        ? <CaptionTable leftCol={<><div className='justify-content-start fw-bold'><Label data={'HeaderStartList'} /></div></>} />
        : <CaptionTable leftCol={<><div className='justify-content-start fw-bold'><Label data={'HeaderResults'} /></div></>} rightCol={<Status typeToPrint='result' scheduleStatus={scheduleStatus} resultStatus={resultStatus} />} />

    if (trial || training) {
        configuration.sortBy = isStartList
            ? [{ id: 'Bib', desc: false }]
            : isLive
                ? [{ id: 'Bib', desc: false }]
                : [{ id: 'Bib', desc: false }]

        configuration.filters = {
            ei_type: ['DISPLAY'],
            ei_code: ['CURRENT']
        };

        configuration.columns = isStartList
            ? breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsTrialStartSM()
                : ColumnsTrialStart()
            : isLive
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsTrialLiveSM()
                    : ColumnsTrialLive()
                : breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsTrialFinalSM()
                    : ColumnsTrialFinal();
    }
    else if (qual) {
        configuration.sortBy = isStartList
            ? [{ id: 'Bib', desc: false }]
            : isLive
                ? [{ id: 'Rank', desc: false }]
                : [{ id: 'Rank', desc: false }]

        configuration.filters = {
            ei_type: ['DISPLAY'],
            ei_code: ['CURRENT']
        };

        configuration.columns = isStartList
            ? breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsQualStartSM()
                : ColumnsQualStart()
            : isLive
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsQualLiveSM()
                    : ColumnsQualLive()
                : breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsQualFinalSM()
                    : ColumnsQualFinal();
    }

    if (trial || training) {
        configuration.columnsWhere = isStartList
            ? breakPoint === "sm" || breakPoint === "xs"
                ? "ColumnsTrialStartSM()"
                : "ColumnsTrialStart()"
            : isLive
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? "ColumnsTrialLiveSM()"
                    : "ColumnsTrialLive()"
                : breakPoint === "sm" || breakPoint === "xs"
                    ? "ColumnsTrialFinalSM()"
                    : "ColumnsTrialFinal()";
    }
    else if (qual) {
          configuration.columnsWhere = isStartList
            ? breakPoint === "sm" || breakPoint === "xs"
                ? "ColumnsQualStartSM()"
                : "ColumnsQualStart()"
            : isLive
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? "ColumnsQualLiveSM()"
                    : "ColumnsQualLive()"
                : breakPoint === "sm" || breakPoint === "xs"
                    ? "ColumnsQualFinalSM()"
                    : "ColumnsQualFinal()";
    }

    //console.log('SjpTrialResults  - ' + configuration.columnsWhere)

    return configuration;
};



const SjpTrialResults = ({ data, caption, config }) => {
    const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;
    const isStartList = isStartListStatus(resultStatus) ? true : false
    const isLive = isLiveStatus(resultStatus) ? true : false
    const isFinish = isFinishedStatus(resultStatus) ? true : false

    const training = data?.results?.eventUnitCode.includes('TRNO')
    const trial = data?.results?.eventUnitCode.includes('FNL-TR') || data?.results?.eventUnitCode.includes('QUALTR')
    const qual = data?.results?.eventUnitCode.includes('QUAL0001')

    const configEvent = useMemo(() => getConfiguration(data, mirs_rsc, resultStatus, breakPoint, caption), [resultStatus, breakPoint]);

    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(({ row }) => {

        let componentExpanded = '';
        componentExpanded = <TE row={row?.original} officials={data?.results?.officials} />
        return (
            <LoaderSubComponent component={componentExpanded} />
        )
    }, [resultStatus]);


    const items = data?.results?.items
    const showAll = items?.some(item => item?.eventUnitEntries?.some(item => item.eue_pos === '1'));
    const hasConfiguration = configEvent.configs.columnsAdded;

    //Si el contenido de una columna esta vacia la ocultamos(ver casos)
    //Pasamos el id de la columna a ocultar definido en la configuracón de
    let hiddenColumns = []
    if (!hasConfiguration) hiddenColumns.push('Expander')

    if (!showAll && !hasConfiguration) hiddenColumns.push('Expander')

    if (isFinish && qual) {
        hiddenColumns.push('Bib')
    }

    if (isStartList && trial) {
        hiddenColumns.push('Expander')
    }

    console.log(data?.results?.items)
    return (
        <>

            {data?.results ?
                (
                    <>
                        {training && isLive
                            ?
                            <>
                                <PreviousCompetitor data={data} />
                                <CurrentCompetitor data={data} />
                            </>
                            : ''
                        }
                        {isLive
                            ? <>&ensp;<StartStatus data={data} /></>
                            : ''
                        }
                        {training || trial
                            ? <></>
                            : <div className="fw-bold"><SportCode discipline={mirs_discipline} entity={'@QualRule'} code={'UT50^R1'} /></div>
                        }
                        {data?.results?.items ? (
                            < MirsTable
                                className='table-result'
                                //Dato to show by row
                                data={data.results.items}
                                //Columnas a visualizar 
                                columns={configEvent.columns}
                                //subcomponente a renderizar, extended
                                renderRowSubComponent={renderRowSubComponent}
                                //pageSizeCustom={data.items.length} //ponerlo por defecto en el componente                             
                                //Key by row necesary in order to no paint innecesary
                                keyRow='participant-code'
                                //Splits to show
                                //current split (initial)
                                //Component caption
                                caption={configEvent.caption}
                                //Columns to hidde 
                                hiddenColumns={hiddenColumns}
                                //When show tble is sorted by 
                                initialSortBy={configEvent.sortBy}
                                //Show buttons move to splits 
                                showNavExtendedData={true}
                                id={`mirs-table-result-${mirs_rsc}`}
                                hasRelatedTimeline={true}
                            />
                        ) : ('')
                        }
                        {data?.config || config
                            ? <HillData config={data?.config || config} />
                            : ''
                        }
                        {data?.results?.officials
                            ?
                            <>
                                <Jury officials={data?.results?.officials} />
                                <Judges officials={data?.results?.officials} />
                            </>
                            : ''
                        }
                    </>
                ) : (
                    <span><em>No data available</em></span>
                )
            }

        </>
    );
};

export default SjpTrialResults;
